"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUpdateAuctionHouseInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const updateAuctionHouseStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['sellerFeeBasisPoints', beet.coption(beet.u16)],
    ['requiresSignOff', beet.coption(beet.bool)],
    ['canChangeSalePrice', beet.coption(beet.bool)],
], 'UpdateAuctionHouseInstructionArgs');
const updateAuctionHouseInstructionDiscriminator = [84, 215, 2, 172, 241, 0, 245, 219];
function createUpdateAuctionHouseInstruction(accounts, args) {
    const { treasuryMint, payer, authority, newAuthority, feeWithdrawalDestination, treasuryWithdrawalDestination, treasuryWithdrawalDestinationOwner, auctionHouse, } = accounts;
    const [data] = updateAuctionHouseStruct.serialize({
        instructionDiscriminator: updateAuctionHouseInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: treasuryMint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: payer,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: authority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: newAuthority,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: feeWithdrawalDestination,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: treasuryWithdrawalDestination,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: treasuryWithdrawalDestinationOwner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: auctionHouse,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.ASSOCIATED_TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('hausS13jsjafwWwGqZTUQRmWyvyxn9EQpqMwV1PBBmk'),
        keys,
        data,
    });
    return ix;
}
exports.createUpdateAuctionHouseInstruction = createUpdateAuctionHouseInstruction;
//# sourceMappingURL=updateAuctionHouse.js.map